module.exports = __webpack_public_path__ + "b2182a8fa22abee78466cc9521836198.png";


//////////////////
// WEBPACK FOOTER
// ./work/sociallyfox/img/note.png
// module id = 748
// module chunks = 0